import { lazyWithPreload } from '@kk/shared/utils/async';
import type { ExtendedRouteObject } from '@/routes/types';
// import { id as leasingsId } from './Leasing/loader';
import loader, { id, type LoaderData, type Params } from './loader';

const AgreementsPage = lazyWithPreload(() => import('./index'));
const Agreements = lazyWithPreload(() => import('./Agreements'));

const MasterAgreements = lazyWithPreload(
  () => import('./Master/MasterAgreements'),
);
const FrameworkAgreements = lazyWithPreload(
  () => import('./Framework/FrameworkAgreements'),
);
const LeasingAgreements = lazyWithPreload(
  () => import('./Leasing/LeasingAgreements'),
);

const MasterAgreementDetails = lazyWithPreload(
  () => import('./Master/Details/MasterAgreementDetails'),
);
const MasterInfo = lazyWithPreload(() => import('./Master/Details/MasterInfo'));
const MasterDocuments = lazyWithPreload(
  () => import('./Master/Details/MasterDocuments'),
);
const FrameworkAgreementDetails = lazyWithPreload(
  () => import('./Framework/Details/FrameworkAgreementDetails'),
);
const FrameworkInfo = lazyWithPreload(
  () => import('./Framework/Details/FrameworkInfo'),
);
const FrameworkDocuments = lazyWithPreload(
  () => import('./Framework/Details/FrameworkDocuments'),
);
const LeasingAgreementDetails = lazyWithPreload(
  () => import('./Leasing/Details/LeasingAgreementDetails'),
);
const LeasingInfo = lazyWithPreload(
  () => import('./Leasing/Details/LeasingInfo'),
);
const LeasingDocuments = lazyWithPreload(
  () => import('./Leasing/Details/LeasingDocuments'),
);
const LeasingPaymentSummary = lazyWithPreload(
  () => import('./Leasing/Details/LeasingPaymentSummary'),
);
const LeasingSupplierInvoices = lazyWithPreload(
  () => import('./Leasing/Details/LeasingSupplierInvoices'),
);
const LeasingObjectDetails = lazyWithPreload(
  async () =>
    await import('./Leasing/Details/LeasingObject/LeasingObjectDetails'),
);
const LeasingObjectInfo = lazyWithPreload(
  () => import('./Leasing/Details/LeasingObject/LeasingObjectInfo'),
);
const LeasingObjectDocuments = lazyWithPreload(
  () => import('./Leasing/Details/LeasingObject/LeasingObjectDocuments'),
);

export default {
  id,
  path: '/agreements',
  loader,
  element: <AgreementsPage />,
  children: [
    {
      id: 'agreement-categories',
      path: '',
      element: <Agreements />,
      children: [
        {
          id: 'master-agreements',
          path: 'masteragreements',
          element: <MasterAgreements />,
        },
        {
          id: 'framework-agreements',
          path: 'frameworkagreements',
          element: <FrameworkAgreements />,
        },
        {
          id: 'leasing-agreements',
          path: 'leasingagreements',
          index: true,
          element: <LeasingAgreements />,
        },
      ],
    },

    {
      id: 'master-details',
      path: 'masteragreements/:masterId',
      element: <MasterAgreementDetails />,
      children: [
        {
          id: 'master-info-tab',
          index: true,
          element: <MasterInfo />,
        },
        {
          id: 'master-docs-tab',
          path: 'docs',
          element: <MasterDocuments />,
        },
      ],
    },

    {
      id: 'framework-details',
      path: 'frameworkagreements/:frameworkId',
      element: <FrameworkAgreementDetails />,
      children: [
        {
          id: 'framework-info-tab',
          index: true,
          element: <FrameworkInfo />,
        },
        {
          id: 'framework-docs-tab',
          path: 'docs',
          element: <FrameworkDocuments />,
        },
      ],
    },

    {
      id: 'leasing-details',
      path: 'leasingagreements/:leasingId',
      element: <LeasingAgreementDetails />,
      children: [
        {
          id: 'leasing-info-tab',
          index: true,
          element: <LeasingInfo />,
        },
        {
          id: 'leasing-docs-tab',
          path: 'docs',
          element: <LeasingDocuments />,
        },
        {
          id: 'leasing-paymentsummary-tab',
          path: 'paymentsummary',
          element: <LeasingPaymentSummary />,
        },
        {
          id: 'leasing-supplierinvoices-tab',
          path: 'supplierinvoices',
          element: <LeasingSupplierInvoices />,
        },
      ],
    },

    {
      id: 'leasing-object-details',
      path: 'leasingobjects/:leasingCode/:leasingObjectCode/:generation',
      element: <LeasingObjectDetails />,
      children: [
        {
          id: 'leasing-object-info-tab',
          index: true,
          element: <LeasingObjectInfo />,
        },
        {
          id: 'leasing-object-docs-tab',
          path: 'docs',
          element: <LeasingObjectDocuments />,
        },
      ],
    },
  ],
  handle: ({ params }) => {
    return {
      preload: async () =>
        await Promise.all([AgreementsPage.preload(), loader({ params })]),
    };
  },
} as const satisfies ExtendedRouteObject<Params, LoaderData>;
